import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { GraduationCapIcon, ChevronDownIcon } from 'lucide-react';
import { findDegreesTemplates } from '../data/findDegreesTemplates';
function slugToLabel(slug: string): string {
  return slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [isFindDegreesOpen, setIsFindDegreesOpen] = useState(false);
  const scrollToTop = () => window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  return <footer className="bg-navy-dark text-white pt-16 pb-8" data-id="element-128" data-mp="3lelzi2xtwhm3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129" data-mp="3le2fmgombj5f">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-130" data-mp="3qcdsz1e4gbse">
          {/* Brand Col */}
          <div className="col-span-1 md:col-span-1" data-id="element-131" data-mp="29y5g5yj5lgty">
            <Link to="/" onClick={scrollToTop} className="flex items-center mb-4" data-id="element-132" data-mp="2a1jhr4jztm0c">
              <GraduationCapIcon className="h-8 w-8 text-gold mr-2" data-id="element-133" data-mp="3l8qy89n2utu3" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-134" data-mp="3gapcfgy9ogex">
                OnlineCollege<span className="text-gold" data-id="element-135" data-mp="3v7q5bns72hez">Guide</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-136" data-mp="3v5dh4svufath">
              Empowering students to find the perfect online degree program to
              advance their careers and achieve their goals.
            </p>
          </div>

          {/* Links Col 1 */}
          <div data-id="element-137" data-mp="33nlc2qvddj4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-138" data-mp="31umvaqetzm7">
              Top Programs
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-139" data-mp="ct77bh9vpni7">
              <li data-id="element-140" data-mp="cuiku8t4m9mi">
                <Link to="/degrees/business" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-141" data-mp="cw34h3dwk85l">
                  Business Administration
                </Link>
              </li>
              <li data-id="element-142" data-mp="tt09erhmoor0">
                <Link to="/degrees/computer-science" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-143" data-mp="yu7h6qjrtnxo">
                  Computer Science
                </Link>
              </li>
              <li data-id="element-144" data-mp="18ltwoz356968">
                <Link to="/degrees/healthcare" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-145" data-mp="1clum1ers44s2">
                  Nursing & Healthcare
                </Link>
              </li>
              <li data-id="element-146" data-mp="1rilf76av0k98">
                <Link to="/degrees/psychology" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-147" data-mp="1rj4yorg5rgpd">
                  Psychology
                </Link>
              </li>
            </ul>

            {/* Find Degrees Dropdown */}
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-3" data-id="element-148" data-mp="2agevdmoqg595">
              Find Degrees
            </h3>
            <div className="relative" data-id="element-149" data-mp="21mti67s7uw1u">
              <button type="button" onClick={() => setIsFindDegreesOpen(open => !open)} aria-expanded={isFindDegreesOpen} aria-haspopup="listbox" className="w-full flex items-center justify-between px-3 py-2 text-sm bg-white/5 hover:bg-white/10 border border-white/10 rounded-md text-gray-200 transition-colors" data-id="element-150" data-mp="21nv1ezjdyoun">
                <span data-id="element-151" data-mp="2kbqba8bvniih">Select a theme</span>
                <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${isFindDegreesOpen ? 'rotate-180' : ''}`} data-id="element-152" data-mp="2fe6wn7b9p3q0" />
              </button>

              {isFindDegreesOpen && <ul role="listbox" className="absolute z-20 left-0 right-0 mt-2 bg-navy-dark border border-white/10 rounded-md shadow-xl overflow-hidden" data-id="element-153" data-mp="13ys0u6usohwh">
                  {findDegreesTemplates.length === 0 && <li className="px-3 py-2 text-xs text-gray-500 italic" data-id="element-154" data-mp="2iv1h0qssrq90">
                      No themes available yet
                    </li>}
                  {findDegreesTemplates.map(template => <li key={template.slug} data-id="element-155" data-mp="3bjgrd00zhke0">
                      <Link to={`/find-degrees/${template.slug}`} onClick={() => {
                  setIsFindDegreesOpen(false);
                  scrollToTop();
                }} className="block px-3 py-2 text-sm text-gray-300 hover:bg-white/10 hover:text-white transition-colors" data-id="element-156" data-mp="3bhm61klsvq9e">
                        {slugToLabel(template.slug)}
                      </Link>
                    </li>)}
                </ul>}
            </div>
          </div>

          {/* Links Col 2 */}
          <div data-id="element-157" data-mp="1imuwrfiesx18">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-158" data-mp="1ine7ab5qcj58">
              Resources
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-159" data-mp="1wlcgl2571pdv">
              <li data-id="element-160" data-mp="1rnjdihz6tbht">
                <Link to="/colleges" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-161" data-mp="1rn1bt5tra52i">
                  Partner Colleges
                </Link>
              </li>
            </ul>
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-162" data-mp="1dni58hglf1sb">
              Guides
            </h3>
            <ul className="space-y-3" data-id="element-163" data-mp="18w0a4a193vf9">
              <li data-id="element-164" data-mp="18v8g33nay5r3">
                <Link to="/request-information" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-165" data-mp="l77debct1jjl">
                  Request Information
                </Link>
              </li>
              <li data-id="element-166" data-mp="2l9qg3uc667bx">
                <Link to="/guide/online-christian-colleges" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-167" data-mp="2l96v24r832to">
                  Online Christian Colleges
                </Link>
              </li>
              <li data-id="element-168" data-mp="1xckqq8el6sch">
                <Link to="#" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-169" data-mp="1xd2tzozo26tw">
                  Financial Aid Guide
                </Link>
              </li>
              <li data-id="element-170" data-mp="2bc28i3tgt5cc">
                <Link to="#" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-171" data-mp="2bclo3dvn7hn7">
                  Accreditation Info
                </Link>
              </li>
              <li data-id="element-172" data-mp="1b3472mq88gxt">
                <Link to="#" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-173" data-mp="1b3m3bjcw2v5q">
                  Career Paths
                </Link>
              </li>
              <li data-id="element-174" data-mp="xbz4bbrkb8j9">
                <Link to="#" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-175" data-mp="xch9wz046z3u">
                  Student Success Stories
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Col */}
          <div data-id="element-176" data-mp="jcpzf88t40ul">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-177" data-mp="jcg4r7cth5ik">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-178" data-mp="2dq7b9xzun99s">
              <li data-id="element-179" data-mp="2dp5z1q73kgqh">
                <Link to="/privacy-policy" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-180" data-mp="2dppbirdzacx4">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-181" data-mp="1mjjw5eyhu6e8">
                <Link to="/terms-and-conditions" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-182" data-mp="1mk21r271pwyt">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-183" data-mp="ytpkh0pwunvk">
                <Link to="/cookie-policy" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-184" data-mp="yxdfy5ex1kcx">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-185" data-mp="twpqho6c5bkt">
                <Link to="/do-not-sell-my-info" onClick={scrollToTop} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-186" data-mp="tya8kebgr21s">
                  Do Not Sell My Info
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8" data-id="element-187" data-mp="7o0sollrtjj8">
          <div className="text-xs text-gray-400 space-y-4 text-center md:text-left" data-id="element-188" data-mp="7plla5oiyseg">
            <p data-id="element-189" data-mp="me81sapw1q79">
              <strong data-id="element-190" data-mp="merk3sjgaglt">Advertiser Disclosure:</strong> OnlineCollegeGuide.com is
              an advertising-supported site. Featured or trusted partner
              programs and all school search, finder, or match results are for
              schools that compensate us. This compensation does not influence
              our school rankings, resource guides, or other
              editorially-independent information published on this site.
            </p>
            <p data-id="element-191" data-mp="10dhhl9a6miap">
              <strong data-id="element-192" data-mp="10dr58q7r8dd8">TCPA Disclosure:</strong> By submitting your information
              on this website, you consent to be contacted by our educational
              partners regarding their programs via email, telephone, or text
              message.
            </p>
            <p className="pt-4 text-gray-500" data-id="element-193" data-mp="iuicoirdjy44">
              &copy; {currentYear} OnlineCollegeGuide. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}